import OnboardingBanner from "../../common/onboarding-banner/OnboardingBanner.tsx";
import { useIntl } from "react-intl";
import MiscellaneousHome from "../../../../common/icons/MiscellaneousHome.tsx";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";

export default function MainBanner() {
  const intl = useIntl();
  const brand = useBrandLoaderData();

  const labels = {
    "Visit FAQs": intl.formatMessage({ defaultMessage: "Visit FAQs" }),
    "Learn More": intl.formatMessage({ defaultMessage: "Learn More" }),
  };

  return (
    <OnboardingBanner
      noMargin
      icon={<MiscellaneousHome />}
      title={intl.formatMessage(
        {
          defaultMessage: "Welcome to {brandName}!",
        },
        { brandName: brand.name }
      )}
      body={intl.formatMessage({
        defaultMessage:
          "Use your dashboard to quickly access your content, add new items to your library, jump back into your last study session, and more!",
      })}
      linkText={labels[brand.DashboardBanner.buttonText]}
      href={brand.DashboardBanner.url}
      bannerSeenPreferenceKey={
        UserPreferenceKey.DashboardOnboardingBannerDismissed
      }
    />
  );
}
